import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { strings } from '@constants'
import { Input, Select, Button } from '@baseV2'
import { toggleDrawer } from '@data/state/action/root'
import { MEETING_TYPES } from '../MeetingCard'
import { FormBody, FormFooter, FormSection, SectionLabel } from './styles'

const MEETING_MODE_OPTIONS = [
	{ label: strings('all'), value: '' },
	{ label: strings(['video', 'call']), value: MEETING_TYPES.VIDEO_CALL },
	{ label: strings('in_person'), value: MEETING_TYPES.IN_PERSON },
	{ label: strings(['phone', 'call']), value: MEETING_TYPES.PHONE_CALL },
]

const EMPTY_FILTERS = { title: '', meeting_mobile_number: '', meeting_mode: '', task_id: '' }

const FilterMeetings = ({ filters = {}, onApply }) => {
	const dispatch = useDispatch()
	const [local, setLocal] = useState({
		title: filters.title || '',
		meeting_mobile_number: filters.meeting_mobile_number || '',
		meeting_mode: filters.meeting_mode || '',
		task_id: filters.task_id || '',
	})

	const update = (key) => (value) => setLocal((s) => ({ ...s, [key]: value }))

	const handleApply = () => {
		onApply?.(local)
		dispatch(toggleDrawer(false))
	}

	const handleReset = () => {
		setLocal(EMPTY_FILTERS)
		onApply?.(EMPTY_FILTERS)
		dispatch(toggleDrawer(false))
	}

	const handleCancel = () => dispatch(toggleDrawer(false))

	return (
		<>
			<FormBody>
				<FormSection>
					<SectionLabel>{strings('meeting_title')}</SectionLabel>
					<Input placeholder={strings('meeting_title')} value={local.title} onChange={(e) => update('title')(e.target.value)} />
				</FormSection>

				<FormSection>
					<SectionLabel>{strings('phone_number')}</SectionLabel>
					<Input type='tel' placeholder={strings('enter_phone_number')} value={local.meeting_mobile_number} onChange={(e) => /^[0-9]*$/.test(e.target.value) && update('meeting_mobile_number')(e.target.value.trim())} />
				</FormSection>

				<FormSection>
					<SectionLabel>{strings('meeting_type')}</SectionLabel>
					<Select
						data={MEETING_MODE_OPTIONS}
						displayKey='label'
						primaryKey='value'
						value={MEETING_MODE_OPTIONS.find((o) => o.value === local.meeting_mode) ?? MEETING_MODE_OPTIONS[0]}
						onChange={(option) => update('meeting_mode')(option.value)}
					/>
				</FormSection>

				<FormSection>
					<SectionLabel>{strings(['task', 'id'])}</SectionLabel>
					<Input placeholder={strings(['task', 'id'])} value={local.task_id} onChange={(e) => update('task_id')(e.target.value)} />
				</FormSection>
			</FormBody>

			<FormFooter>
				<Button size='base' onClick={handleApply}>
					{strings('apply')}
				</Button>
				<Button size='base' variant='outline' onClick={handleReset}>
					{strings('reset')}
				</Button>
				<Button size='base' variant='outline' onClick={handleCancel}>
					{strings('cancel')}
				</Button>
			</FormFooter>
		</>
	)
}

export default FilterMeetings
